<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="400px"
  >
    <v-card>
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title>{{ editMedio.MEDIO }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form
          v-model="valid"
          @submit.prevent="aceptar"
        >
          <v-container
            fluid
          >
            <!-- Aviso -->
            <v-row>
              <v-col
                sm="10"
              >
                <vx-date-text-edit
                  v-model="editMedio.FECHA_ALARMADO"
                  label="Alarmado"
                  icon="esri-icon-calendar"
                  :min="fechaIncendio"
                  :max="editMedio.FECHA_EN_CAMINO"
                  not-future
                  required
                  @focus="setCurrentDate('FECHA_ALARMADO')"
                />
              </v-col>
            </v-row>

            <!-- Llegada -->
            <v-row
              align="center"
            >
              <v-col
                sm="10"
              >
                <vx-date-text-edit
                  v-model="editMedio.FECHA_EN_CAMINO"
                  label="En camino"
                  icon="esri-icon-calendar"
                  :min="editMedio.FECHA_ALARMADO"
                  :max="editMedio.FECHA_EN_LUGAR"
                  not-future
                  @focus="setCurrentDate('FECHA_EN_CAMINO')"
                />
              </v-col>

              <v-col
                sm="2"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      :disabled="!editMedio.FECHA_EN_CAMINO"
                      v-on="on"
                      @click="removeFechaLlegada"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar fecha llegada.</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <!-- Salida -->
            <v-row
              align="center"
            >
              <v-col
                sm="10"
              >
                <vx-date-text-edit
                  v-model="editMedio.FECHA_EN_LUGAR"
                  label="En lugar"
                  icon="esri-icon-calendar"
                  :min="editMedio.FECHA_EN_CAMINO"
                  :max="editMedio.FECHA_FINALIZADO"
                  not-future
                  @focus="setCurrentDate('FECHA_EN_LUGAR')"
                />
              </v-col>

              <v-col
                sm="2"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      :disabled="!editMedio.FECHA_EN_LUGAR"
                      v-on="on"
                      @click="removeFechaSalida"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar fecha salida.</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <!-- Llegada base -->
            <v-row
              align="center"
            >
              <v-col
                sm="10"
              >
                <vx-date-text-edit
                  v-model="editMedio.FECHA_FINALIZADO"
                  label="Finalizado"
                  icon="esri-icon-calendar"
                  :min="editMedio.FECHA_EN_LUGAR"
                  :max="editMedio.FECHA_FIN_DESCANSO"
                  not-future
                  @focus="setCurrentDate('FECHA_FINALIZADO')"
                />
              </v-col>

              <v-col
                sm="2"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      :disabled="!editMedio.FECHA_FINALIZADO"
                      v-on="on"
                      @click="removeFechaLlegadaBase"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar fecha llegada base.</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <!-- Fin descanso -->
            <v-row
              align="center"
            >
              <v-col
                sm="10"
              >
                <vx-date-text-edit
                  v-model="editMedio.FECHA_FIN_DESCANSO"
                  label="Fin descanso"
                  icon="esri-icon-calendar"
                  :min="editMedio.FECHA_FINALIZADO"
                  @focus="setCurrentDate('FECHA_FIN_DESCANSO')"
                />
              </v-col>

              <v-col
                sm="2"
              >
                <v-tooltip
                  bottom
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-btn
                      icon
                      color="red"
                      v-bind="attrs"
                      :disabled="!editMedio.FECHA_FIN_DESCANSO"
                      v-on="on"
                      @click="removeFechaFinDescanso"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar fecha fin descanso.</span>
                </v-tooltip>
              </v-col>
            </v-row>

            <!-- Sector -->
            <v-row>
              <v-col>
                <v-select
                  v-model="editMedio.ID_SECTOR"
                  :items="sectores"
                  prepend-icon="esri-icon-description"
                  label="Sector"
                  item-text="SECTOR"
                  item-value="ID_SECTOR"
                  single-line
                  autocomplete
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <!-- <v-btn
          text
          color="red"
          @click="deleteMedioIncendio"
        >
          Eliminar act.
        </v-btn> -->
        <v-spacer />
        <v-btn
          text
          color="red"
          @click="cancelar"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          color="green"
          :disabled="!valid"
          @click="aceptar"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MEDIO_SECTOR_ESTADO } from '@/helpers/constants'
import DateService, { FMT } from '@/helpers/DateService'

export default {
  props: {
    show: Boolean,
    idIncendio: String,
    medioSector: Object
  },

  data: () => ({
    valid: true,

    dateFormat: 'DD/MM/YYYY HH:mm',
    editMedio: {}
  }),

  computed: {
    incendio() {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },

    fechaIncendio() {
      if (!this.incendio) return null
      return DateService.toDayjs(this.incendio.FECHA_CREACION, FMT.date).format(FMT.date)
    },

    sectores() {
      let sectores = []

      if (this.incendio) {
        sectores = this.incendio.SECTORES
      }

      return sectores
    },

    disableFechaSalida() {
      return !this.editMedio.FECHA_EN_CAMINO || DateService.toDayjs(this.editMedio.FECHA_EN_CAMINO, FMT.date) >= DateService.getCurrentDayJs()
    },
    disableFechaLlegadaBase() {
      return !this.editMedio.FECHA_EN_LUGAR || DateService.toDayjs(this.editMedio.FECHA_EN_LUGAR, FMT.date) >= DateService.getCurrentDayJs()
    },
    disableFechaFinDescanso() {
      return !this.editMedio.FECHA_FINALIZADO || DateService.toDayjs(this.editMedio.FECHA_FINALIZADO, FMT.date) >= DateService.getCurrentDayJs()
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.editMedio = JSON.parse(JSON.stringify(this.medioSector))

        // 8061 para datetime
        this.editMedio.FECHA_ALARMADO = this.editMedio.FECHA_ALARMADO ? DateService.toDayjs(this.editMedio.FECHA_ALARMADO, FMT.date).format(FMT.date) : null
        this.editMedio.FECHA_EN_CAMINO = this.editMedio.FECHA_EN_CAMINO ? DateService.toDayjs(this.editMedio.FECHA_EN_CAMINO, FMT.date).format(FMT.date) : null
        this.editMedio.FECHA_EN_LUGAR = this.editMedio.FECHA_EN_LUGAR ? DateService.toDayjs(this.editMedio.FECHA_EN_LUGAR, FMT.date).format(FMT.date) : null
        this.editMedio.FECHA_FINALIZADO = this.editMedio.FECHA_FINALIZADO ? DateService.toDayjs(this.editMedio.FECHA_FINALIZADO, FMT.date).format(FMT.date) : null
        this.editMedio.FECHA_FIN_DESCANSO = this.editMedio.FECHA_FIN_DESCANSO ? DateService.toDayjs(this.editMedio.FECHA_FIN_DESCANSO, FMT.date).format(FMT.date) : null
      } else {
        this.editMedio = {}
      }
    }
  },

  methods: {
    setCurrentDate(field) {
      if (!this.editMedio[field]) {
        this.editMedio[field] = DateService.getCurrentDayJs().format(FMT.date)
      }
    },

    removeFechaLlegada() {
      this.editMedio.FECHA_EN_CAMINO = null
      this.editMedio.FECHA_EN_LUGAR = null
      this.editMedio.FECHA_FINALIZADO = null
      this.editMedio.FECHA_FIN_DESCANSO = null
    },

    removeFechaSalida() {
      this.editMedio.FECHA_EN_LUGAR = null
      this.editMedio.FECHA_FINALIZADO = null
      this.editMedio.FECHA_FIN_DESCANSO = null
    },

    removeFechaLlegadaBase() {
      this.editMedio.FECHA_FINALIZADO = null
      this.editMedio.FECHA_FIN_DESCANSO = null
    },

    removeFechaFinDescanso() {
      this.editMedio.FECHA_FIN_DESCANSO = null
    },

    deleteMedioIncendio() {
      const msg = `Eliminando la actuación del medio: ${this.editMedio.MEDIO}`
      this.$root.$confirmDialog.open('¿Está seguro?', msg).then(result => {
        if (result) {
          this.$emit('deleteMedioIncendio', this.medioSector)
        }
      })
    },

    cancelar() {
      this.$emit('cancelar')
    },

    aceptar() {
      const fechasModificadas = MEDIO_SECTOR_ESTADO.filter(field => {
        const originalFormatted = this.medioSector[field]
          ? DateService.toDayjs(this.medioSector[field], FMT.date).format(FMT.date)
          : null
        return originalFormatted !== this.editMedio[field]
      })

      const editMedio = JSON.parse(JSON.stringify(this.editMedio))
      editMedio.FECHA_ALARMADO = DateService.toDayjs(editMedio.FECHA_ALARMADO, FMT.date).toISOString()
      editMedio.FECHA_EN_CAMINO = editMedio.FECHA_EN_CAMINO ? DateService.toDayjs(editMedio.FECHA_EN_CAMINO, FMT.date).toISOString() : null
      editMedio.FECHA_EN_LUGAR = editMedio.FECHA_EN_LUGAR ? DateService.toDayjs(editMedio.FECHA_EN_LUGAR, FMT.date).toISOString() : null
      editMedio.FECHA_FINALIZADO = editMedio.FECHA_FINALIZADO ? DateService.toDayjs(editMedio.FECHA_FINALIZADO, FMT.date).toISOString() : null
      editMedio.FECHA_FIN_DESCANSO = editMedio.FECHA_FIN_DESCANSO ? DateService.toDayjs(editMedio.FECHA_FIN_DESCANSO, FMT.date).toISOString() : null
      editMedio.NUM_COMPONENTES = this.medioSector.NUM_COMPONENTES
      editMedio.FECHAS_MODIFICADAS = fechasModificadas

      editMedio.FECHA_AVISO_PLANIF = editMedio.FECHA_ALARMADO
      editMedio.FECHA_LLEGADA_PLANIF = editMedio.FECHA_EN_CAMINO
      this.$emit('aceptar', editMedio)
    }
  }
}
</script>

<style scoped>
</style>
